module.exports = __webpack_public_path__ + "static/media/8OLA6.0c26cd56.jpg";